export function getSetup() {
    function decodeString(string: string | null | undefined) {
        return string
            ?.split('')
            .map((c: string) => String.fromCharCode(c.charCodeAt(0) + 13))
            .join('');
    }

    let storage = localStorage.getItem('setup');

    if (!storage) return null;

    let json = JSON.parse(storage);
    json.password = decodeString(json.password) || null;
    json.userPassword = decodeString(json.userPassword) || null;

    return json;
}
